// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../assets/AssetPreview.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type HomeownerNotesForProjectQueryVariables = Types.Exact<{
  filter: Types.HomeownerNoteFilter;
}>;


export type HomeownerNotesForProjectQuery = { __typename?: 'Query', homeownerNotes: Array<{ __typename?: 'HomeownerNote', id: string, title: string, description: string, createdAt: Types.Scalars['DateTime']['input'], createdBy: { __typename?: 'User', id: string, avatarUrl: string, name: string }, jobLogImages: Array<{ __typename?: 'JobLogImage', id: string, createdAt: Types.Scalars['DateTime']['input'], asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> }> };

export type HomeownerNotesForProjectFragment = { __typename?: 'HomeownerNote', id: string, title: string, description: string, createdAt: Types.Scalars['DateTime']['input'], createdBy: { __typename?: 'User', id: string, avatarUrl: string, name: string }, jobLogImages: Array<{ __typename?: 'JobLogImage', id: string, createdAt: Types.Scalars['DateTime']['input'], asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> };

export const HomeownerNotesForProjectFragmentDoc = gql`
    fragment HomeownerNotesForProject on HomeownerNote {
  id
  title
  description
  createdAt
  createdBy {
    id
    avatarUrl
    name
  }
  jobLogImages {
    id
    createdAt
    asset {
      ...AssetInfo
    }
  }
}
    ${AssetInfoFragmentDoc}`;
export const HomeownerNotesForProjectDocument = gql`
    query HomeownerNotesForProject($filter: HomeownerNoteFilter!) {
  homeownerNotes(filter: $filter) {
    ...HomeownerNotesForProject
  }
}
    ${HomeownerNotesForProjectFragmentDoc}`;

/**
 * __useHomeownerNotesForProjectQuery__
 *
 * To run a query within a React component, call `useHomeownerNotesForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeownerNotesForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeownerNotesForProjectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHomeownerNotesForProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables> & ({ variables: HomeownerNotesForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables>(HomeownerNotesForProjectDocument, options);
      }
export function useHomeownerNotesForProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables>(HomeownerNotesForProjectDocument, options);
        }
// @ts-ignore
export function useHomeownerNotesForProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables>;
export function useHomeownerNotesForProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomeownerNotesForProjectQuery | undefined, HomeownerNotesForProjectQueryVariables>;
export function useHomeownerNotesForProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables>(HomeownerNotesForProjectDocument, options);
        }
export type HomeownerNotesForProjectQueryHookResult = ReturnType<typeof useHomeownerNotesForProjectQuery>;
export type HomeownerNotesForProjectLazyQueryHookResult = ReturnType<typeof useHomeownerNotesForProjectLazyQuery>;
export type HomeownerNotesForProjectSuspenseQueryHookResult = ReturnType<typeof useHomeownerNotesForProjectSuspenseQuery>;
export type HomeownerNotesForProjectQueryResult = ApolloReactCommon.QueryResult<HomeownerNotesForProjectQuery, HomeownerNotesForProjectQueryVariables>;